import React, { useState } from 'react';
import { api } from '../axios/AxiosInstances';
import './ResetPassword.css'; // External CSS file
import { Footer } from "./Footer"


const ResetPassword = () => {
    const [data, setData] = useState({
        username: '',
        confirmUsername: '',
    });

    const [error, setError] = useState({});
    const [statusMessage, setStatusMessage] = useState('');
    const [newpassword, setnewpassword] = useState('');
    const [statusType, setStatusType] = useState('');

    function generateRandomPassword(length) {
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        setnewpassword(password)
        return password;
    }
    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
        setError({ ...error, [`${e.target.name}NotValid`]: false });
    };

    const handleReset = async () => {
        let hasError = false;
        const newError = {};

        if (!data.username) {
            newError.usernameNotValid = true;
            newError.usernameNotValidText = 'Username is required';
            hasError = true;
        }

        if (!data.confirmUsername) {
            newError.confirmUsernameNotValid = true;
            newError.confirmUsernameNotValidText = 'Confirm Username is required';
            hasError = true;
        }

        if (data.username !== data.confirmUsername) {
            newError.confirmUsernameNotValid = true;
            newError.confirmUsernameNotValidText = 'Usernames do not match';
            hasError = true;
        }

        if (hasError) {
            setError(newError);
            return;
        }

        try {
            const response = await api.post('/resetuserpassword', {
                username: data.username,
                newpassword: generateRandomPassword(7)
            });

            if (response.data.status === 'passwordchanged') {
                setStatusType('success');
                setStatusMessage('Password reset successfully!');
            } else if (response.data.status == "usernotfound") {
                setStatusType('error');
                setStatusMessage('User not found on server');
            } else {
                setStatusType('error');
                setStatusMessage(response.data.message || 'Reset failed');
            }
        } catch (error) {
            console.error('API error:', error);
            setStatusType('error');
            setStatusMessage('Something went wrong!');
        }
    };

    return (
        <div className="reset-container">
            <h2 className="reset-heading">Reset user password</h2>

            <div className="reset-row">
                <label className="reset-label">
                    Username<span className="required">*</span>
                </label>
                <input
                    type="text"
                    name="username"
                    className="reset-input"
                    value={data.username}
                    onChange={handleChange}
                />
            </div>
            {error.usernameNotValid && (
                <div className="reset-error">{error.usernameNotValidText}</div>
            )}

            <div className="reset-row">
                <label className="reset-label">
                    Confirm Username<span className="required">*</span>
                </label>
                <input
                    type="text"
                    name="confirmUsername"
                    className="reset-input"
                    value={data.confirmUsername}
                    onChange={handleChange}
                />
            </div>
            {error.confirmUsernameNotValid && (
                <div className="reset-error">{error.confirmUsernameNotValidText}</div>
            )}

            <button className="reset-button" onClick={handleReset}>
                Confirm
            </button>

            {statusMessage && (
                <div
                    className={
                        statusType === 'success' ? 'reset-success' : 'reset-failure'
                    }
                >
                    {statusMessage}&nbsp;&nbsp;{newpassword}
                </div>
            )}
            <Footer position='absolute' />
        </div>

    );

};

export default ResetPassword;
